import type { Locale } from "@/lib/i18n";
import { pl, type CInteractiveMapTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cInteractiveMapTranslations: Record<Locale, CInteractiveMapTranslations> = {
  pl,
  en,
  de,
};

export type { CInteractiveMapTranslations };
